<div class="thankyou-container">
  <img src="assets/genai-agency/media/thankyouComponents/thankyou.png" alt="Thank You" class="thankyou-image" />

  <!-- Arabic -->
  <p class="thankyou-message">
    سيتواصل معك فريق المبيعات لدينا في أقرب وقت ممكن
  </p>

  <!-- English -->
  <p  class="thankyou-message">
    Our sales team will contact you ASAP
  </p>

  <!-- German -->
  <p  class="thankyou-message">
    Unser Vertriebsteam wird Sie so schnell wie möglich kontaktieren
  </p>
</div>
